export default {
	default: [''],
	defaultBg1: ['card--bg-1'],
	defaultBg2: ['card--bg-2']
};
